<template>
  <container v-if="colors" :class="['colors', 'mb-4']">
    <flex :spacing="3" v-for="(swatches, color) in colors" :key="color">
      <flex-col equal-height :span="24">
        <h-three :title="color" />
      </flex-col>
      <flex-col equal-height :span="21" v-if="!swatches.length" :class="['text-xs']">
        <table-layout equal-cells x-align="center" y-align="middle">
          <row>
            <cell @click.native="copyToClipboard(setColor(color))" v-ripple v-html="setColor(color)" :title="$lang.clickToCopy" :class="[setColor(color), 'py-2', 'cursor-pointer', ['black', 'bcq'].includes(color) ? 'text-white' : null]" />
          </row>
          <row>
            <cell @click.native="copyToClipboard(setColor(color, null, false))" v-ripple v-html="setColor(color, null, false)" :title="$lang.clickToCopy" :class="[setColor(color, null, false), 'py-2', 'cursor-pointer', color === 'white' ? 'bg-black' : null]" />
          </row>
        </table-layout>
      </flex-col>
      <flex-col equal-height md6 sm12 xs24 :span="2" v-else v-for="(swatch, index) in swatches" :key="index" :class="['text-xs']">
        <table-layout equal-cells x-align="center" y-align="middle" :class="['colors-swatch', 'shadow-lg']">
          <row>
            <cell @click.native="copyToClipboard(setColor(color, swatch))" v-ripple :title="$lang.clickToCopy" :class="[setColor(color, swatch), 'p-2', 'cursor-pointer', setColor(color, swatches[swatches.length - index - 1], false)]">
              <code v-html="setColor(color, swatch)" />
            </cell>
          </row>
          <row>
            <cell @click.native="copyToClipboard(setColor(color, swatch, false))" v-ripple :title="$lang.clickToCopy" :class="[setColor(color, swatch, false), setColor(color, swatches[swatches.length - index - 1]), 'p-2', 'cursor-pointer']">
              <code v-html="setColor(color, swatch, false)" />
            </cell>
          </row>
        </table-layout>
      </flex-col>
    </flex>
    <snackbar v-model="snackbar" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness">{{ $lang.copiedToClipboard(copiedValue) }}</snackbar>
  </container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'Colors',
  mixins: [
    methods
  ],
  data () {
    return {
      colors: null,
      snackbar: false,
      copiedValue: null
    }
  },
  mounted () {
    this.getExternalData('colors.json', 'colors')
  },
  methods: {
    setColor (color, swatch, bgColor = true) {
      return `${bgColor ? 'bg' : 'text'}-${color}${swatch ? '-' + swatch : ''}`
    }
  }
}
</script>
<style>
.colors .colors-swatch .bcq-table-layout-cell
{
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/colors.vue